import { httpClient } from '@/lib/http-client'

export const industriesApi = {
    list: () => httpClient.get('/industries'),
    get: (id: string) => httpClient.get(`/industries/${id}`),
    create: (data: { name: string; code: string; description?: string; icon?: string }) =>
        httpClient.post('/industries', data),
    update: (id: string, data: { name?: string; code?: string; description?: string; icon?: string; is_active?: boolean }) =>
        httpClient.put(`/industries/${id}`, data),
    delete: (id: string) => httpClient.delete(`/industries/${id}`),

    // Benchmarks
    setBenchmarks: (id: string, benchmarks: Array<{ domain_id: string; target_level: number; description?: string }>) =>
        httpClient.put(`/industries/${id}/benchmarks`, { benchmarks }),
    importData: (form: FormData) =>
        httpClient.post('/industries/import', form, {
            headers: { 'Content-Type': 'multipart/form-data' },
        }),
    exportUrl: (format: string) => `/api/industries/export?format=${format}`,
}
